<template>
  <span v-if="imgsrc && imgsrc.fileType === 'image'" class="logoCropper">
    <Cropper v-if="imgsrc!=={} && imgsrc.fileType === 'image'"  ref="cropperRef" @change="onChange" class="logoAvatar-cropper cropper" :src="imgsrc.url"
      :auto-zoom="true" image-class="cropper__image" :stencil-component="stencil"
      :class="{ 'types-classic-cropper--small-height': smallHeight }" :default-boundaries="defaultBoundaries"
      :resize-image="resizeImage" :default-size="defaultSize" :default-visible-area="defaultVisibleArea"
      :image-restriction="imageRestriction" />
    <div :class="isTablet
      ? 'vertical-buttons'
      : 'horizontal-buttons grid grid-cols-6 margin-top'
      ">
      <f7-link @click="toggleStencil()  " class="square-button"
        :icon-ios="stencil_component ? 'f7:circle' : 'f7:rectangle'" :icon-md="stencil_component ? 'material:radio_button_unchecked' : 'material:crop_5_4'
          "></f7-link>

      <f7-link @click="flip(true, false)" class="square-button" icon-ios="material:flip"
        icon-md="material:flip"></f7-link>
      <f7-link @click="flip(false, true)" class="square-button flipRotate" icon-ios="material:flip"
        icon-md="material:flip"></f7-link>
      <f7-link @click="rotate(90)" icon-aurora="f7:rotate_right" icon-ios="f7:rotate_right"
        icon-md="material:rotate_right" class="square-button"></f7-link>
      <f7-link class="square-button" @click="rotate(-90)" icon-aurora="f7:rotate_left" icon-ios="f7:rotate_left"
        icon-md="material:rotate_left"></f7-link>
      <f7-link class="square-button" @click="saveCroppedImage()" icon-aurora="material:save" icon-ios="material:save"
        icon-md="material:save"></f7-link>
    </div>
  </span>
</template>
<style scoped lang="scss">
.types-classic-cropper {
  max-height: 500px;
  background: black;

  &--small-height {
    max-height: 400px;
  }
}

.cropper-stencil {
  &__preview {

    &:after,
    &:before {
      content: "";
      opacity: 0;
      transition: opacity 0.25s;
      position: absolute;
      pointer-events: none;
      z-index: 1;
    }

    &:after {
      border-left: solid 1px white;
      border-right: solid 1px white;
      width: 33%;
      height: 100%;
      transform: translateX(-50%);
      left: 50%;
      top: 0;
    }

    &:before {
      border-top: solid 1px white;
      border-bottom: solid 1px white;
      height: 33%;
      width: 100%;
      transform: translateY(-50%);
      top: 50%;
      left: 0;
    }
  }

  &--dragging {
    .cropper-stencil__preview {

      &:after,
      &:before {
        opacity: 0.7;
      }
    }
  }
}

.cropper-line {
  border-color: rgba(white, 0.8);
}

.cropper-handler-wrapper {
  width: 24px;
  height: 24px;

  &--west-north {
    transform: translate(0, 0);
  }

  &--east-south {
    transform: translate(-100%, -100%);
  }

  &--west-south {
    transform: translate(0, -100%);
  }

  &--east-north {
    transform: translate(-100%, 0);
  }
}

.cropper-handler {
  display: block;
  position: relative;
  flex-shrink: 0;
  transition: opacity 0.5s;
  border: none;
  background: white;
  height: 4px;
  width: 4px;
  opacity: 0;
  top: auto;
  left: auto;

  &--west-north,
  &--east-south,
  &--west-south,
  &--east-north {
    display: block;
    height: 16px;
    width: 16px;
    background: none;
    opacity: 0.7;
  }

  &--west-north {
    border-left: solid 2px white;
    border-top: solid 2px white;
  }

  &--east-south {
    border-right: solid 2px white;
    border-bottom: solid 2px white;
  }

  &--west-south {
    border-left: solid 2px white;
    border-bottom: solid 2px white;
  }

  &--east-north {
    border-right: solid 2px white;
    border-top: solid 2px white;
  }

  &--hover {
    opacity: 1;
  }
}

.logoCropper {
  max-height: calc(100vh - var(--f7-navbar-height));
  max-width: 90%;
  width: calc(100vw - var(--f7-navbar-height));
}

.square-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 999px;
  cursor: pointer;
  color: var(--avocash-pit, #1c1c1e);
  transition: background 0.2s ease, color 0.2s ease, transform 0.1s ease;

  &:active {
    background: var(--avocash-green-light, #eaf2eb);
    color: var(--avocash-green, #1a6b42);
    transform: scale(0.92);
  }
}

.horizontal-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(28, 28, 30, 0.06);
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(28, 28, 30, 0.1);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  backdrop-filter: saturate(180%) blur(12px);
}

.vertical-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(28, 28, 30, 0.06);
  border-radius: 999px;
  box-shadow: 0 8px 24px rgba(28, 28, 30, 0.1);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  backdrop-filter: saturate(180%) blur(12px);
}

.flipRotate {
  transform: rotate(90deg);
}
</style>
<script setup>
import { f7, theme } from "framework7-vue";
import { Cropper, CircleStencil, RectangleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { markRaw, ref, shallowRef, computed } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { useAttachDocs } from "@/js/composables/useAttachDocs.js";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
  isToSave: Boolean,
  imageSrc: {
    type: Object,
    default: {},},
  
  img: {
    type: String,
  },
  defaultBoundaries: {
    type: String,
    default: "fit",
  },
  resizeImage: {
    type: Object,
  },
  defaultVisibleArea: {
    type: Object,
  },
  imageRestriction: {
    type: String,
    default: "fill-area",
  },
  smallHeight: {
    type: Boolean,
  },
});
const imgsrc=computed(() => props.imageSrc)
const authStore = useAuthStore();
const { getProfile, isAuthenticated, isProfileLoaded, profile, documentsUrl, document } = storeToRefs(authStore);
const isTablet = useTabletScreen().matches;

const { attachFileOpenActions, getFileMimeType, removeDoc, editImage, photoList } = useAttachDocs({ f7route: props.f7route, f7router: props.f7router });

const coordinates = ref({
  width: 0,
  height: 0,
  left: 0,
  top: 0,
});
const stencil = shallowRef(markRaw(RectangleStencil));
const stencil_component = ref(true);
const image = ref("");
const cropperRef = ref(null);
const parameters = ref({
  stencil_props: {
    class: "cropper-stencil",
    previewClass: "cropper-stencil__preview",
    draggingClass: "cropper-stencil--dragging",
    handlersClasses: {
      default: "cropper-handler",
      eastNorth: "cropper-handler--east-north",
      westNorth: "cropper-handler--west-north",
      eastSouth: "cropper-handler--east-south",
      westSouth: "cropper-handler--west-south",
    },
    handlersWrappersClasses: {
      default: "cropper-handler-wrapper",
      eastNorth: "cropper-handler-wrapper--east-north",
      westNorth: "cropper-handler-wrapper--west-north",
      eastSouth: "cropper-handler-wrapper--east-south",
      westSouth: "cropper-handler-wrapper--west-south",
    },
  },
  stencil_component: "rectangle-stencil",
  stencil_size: { width: (f7.width * 90) / 100, height: (f7.height * 90) / 100 },
  image_restriction: "none",
  default_size: "defaultSize",
});

function toggleStencil() {
  stencil.value = markRaw(stencil.value === RectangleStencil ? CircleStencil : RectangleStencil);
  stencil_component.value = stencil.value === RectangleStencil;
}

function rotate(angle) {
  cropperRef.value?.rotate(angle);
}

function flip(horizontal, vertical) {
  cropperRef.value?.flip(horizontal, vertical);
}

function defaultSize({ imageSize, visibleArea }) {
  return {
    width: (visibleArea || imageSize).width,
    height: (visibleArea || imageSize).height,
  };
}

function resize(width, height, left, top) {
  cropperRef.value?.setCoordinates({ width, height, left, top });
}

function onChange({ coordinates: coords, canvas }) {
  coordinates.value = coords;
  if (canvas) image.value = canvas.toDataURL();
}

function saveCroppedImage() {
  const result = cropperRef.value?.getResult();
  if (!result) return Promise.resolve(null);

  return new Promise((resolve) => {
    result.canvas.toBlob((blob) => {
      if (!blob) return resolve(null);
      const original = props.imageSrc;
      const type = original.contentType || "image/jpeg";
      const file = new File([blob], original.fileName || `image_${Date.now()}.jpg`, { type });
      if (original.url?.startsWith("blob:")) URL.revokeObjectURL(original.url);
      useAuthStore().setDocumentsUrl({
        ...original,
        file,
        url: URL.createObjectURL(file),
        size: file.size,
        contentType: type,
        fileType: "image",
      });
      useAuthStore().selectDocument({});
      resolve(file);
    }, props.imageSrc.contentType || "image/jpeg", 0.92);
  });
}

defineExpose({ saveCroppedImage });
</script>
